import React from 'react';

const FacetContext = React.createContext();

export const FacetProvider = FacetContext.Provider;
export const FacetConsumer = FacetContext.Consumer;
export default FacetContext;
